module.exports = __webpack_public_path__ + "img/dance-school-icon5.0e1fa7f6.png";